<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>not_interested</mat-icon>
        <div style="margin-left: 10px;">Página não encontrada!</div>
      </div>

    </mat-toolbar>
  </mat-card>

  </div>